// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Editor from '@tinymce/tinymce-vue'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import '@/assets/css/han.css'
import '@/assets/css/ryu.css'

Vue.config.productionTip = false
Vue.component('editor', Editor)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  store,
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js